import { render, staticRenderFns } from "./ZiyaratDealList.vue?vue&type=template&id=482ceceb&scoped=true&"
import script from "./ZiyaratDealList.vue?vue&type=script&lang=js&"
export * from "./ZiyaratDealList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482ceceb",
  null
  
)

export default component.exports